module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1001-6423307eda056582b5cef5eec1dd694b.png";